import { ITooltipParams } from "ag-grid-community";

export const GenericTooltipValueGetter = (params: ITooltipParams) => {
  // null

  let colDef = params.colDef;

  // if (Object.prototype.hasOwnProperty.call(params, 'rowIndex') == false)
  //   return colDef.headerName;

  if (params.valueFormatted != null) {
    // HTML will be stripped from this by ag-grid
    return params.valueFormatted;
  }

  if (params.value != null) {
    return params.value;
  } else if (colDef.valueGetter != null) {
    if (typeof colDef.valueGetter == "string") return colDef.valueGetter;
    else if (typeof colDef.valueGetter == "function") return colDef.valueGetter(params as any);
  }

  return "";
};
